import React, {ReactElement} from 'react';
import ShareIcon from 'assets/share.svg';
import {Container, Top, Bottom} from './style';

export const StartupView = (): ReactElement => (
  <Container>
    <Top>Добавьте «Тяжеловато» на экран «Домой» из меню снизу.</Top>
    <Bottom>
      Откройте страницу в Сафари и нажмите 
      <img src={ShareIcon} width='15' alt='Иконка «Поделиться»' />
    </Bottom>
  </Container>
);
